import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { WhiteSpace } from 'antd-mobile';
import { createBrowserHistory } from "history";
import { CommonlyHead } from '../common/headnav';
import { Footer } from '../common/footerbar';
import { Button } from 'antd-mobile';
import * as services from '../projects/services';
import './style.less';
const history = createBrowserHistory();
export default class Members extends Component {
    constructor(props) {
        super(props);
        // let m_user =null;
        // if (!!localStorage.getItem('QUANREN_SSO_MM_USER_CACHE')) {
        //     m_user = JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE'));
        // }
        this.state = {
            m_user: null
        }
    }
    componentDidMount() {
        let m_user = null;
        if (!localStorage.getItem('QUANREN_SSO_MM_USER_CACHE')) {
            services.GetUserClaims('').then(data => {
                if (data.status === 0) {
                    localStorage.setItem('QUANREN_SSO_MM_USER_CACHE', JSON.stringify(data.result));
                    m_user = JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE'));
                    this.setState({m_user:m_user});
                } 
            });
        }else{
            m_user = JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE'));
            this.setState({m_user:m_user});
        }
    }
    render() {
        const { m_user } = this.state;
        return <div className="members" style={{ height: document.documentElement.clientHeight - 50 }}>
            <CommonlyHead barname='个人中心' />
            {
                !!m_user ?
                    <div>
                        <div className="memberTop">
                            <img alt='' src={require('../../res/images/user/bg.png')} />
                            <div className="topText">
                                <img alt='' src={require('../../res/images/user/kh.png')} />
                                <div className="ctext">
                                    <div>{m_user === null ? '' : m_user.fullname}</div>
                                    <div>全人健康欢迎您的到来</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''
            }
            <WhiteSpace />
            <div className="linkbox">
                <Link to={`/members/orderment/${0}`}><img alt='' src={require('../../res/images/user/ico-dyy.png')} />待预约</Link>
                <Link to='/members/orderment/1'><img alt='' src={require('../../res/images/user/ico-dtj.png')} />待体检</Link>
                <Link to='/members/orderment/2'><img alt='' src={require('../../res/images/user/ico-ytj.png')} />已体检</Link>
                <Link className="line" to='/'><img alt='' src={require('../../res/images/user/ico-line.png')} /></Link>
                <Link to='/members/report'><img alt='' src={require('../../res/images/user/ico-wdtj.png')} />我的报告</Link>
            </div>
            <WhiteSpace />
            <div className="list clist">
                <div className="item">
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-dd.png')} alt='' />
                    </div>
                    <div className="item-text">订单管理</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                        onClick={() => {
                            history.push('/members/order');
                            history.go();
                        }
                        }  >查看</Button></div>
                </div>
                <div className="item" onClick={() => {
                            history.push('/members/integral');
                            history.go();
                        }
                        }>
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-jkjfl.png')} alt='' />
                    </div>
                    <div className="item-text">健康积分</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                        
                    >查看</Button></div>
                </div>
                <div className="item"  onClick={() => {
                            history.push(`/members/consume/0`);
                            history.go();
                        }
                        }>
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-xfjl.png')} alt='' />
                    </div>
                    <div className="item-text">健康积分消费记录</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                       
                    >查看</Button></div>
                </div>
                <div className="item" onClick={() => {
                            history.push(`/members/people`);
                            history.go();
                        }
                        }>
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-tjr.png')} alt='' />
                    </div>
                    <div className="item-text">体检人管理</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                        
                    >查看</Button></div>
                </div>
                <div className="item" onClick={() => {
                            history.push(`/members/address`);
                            history.go();
                        }
                        }>
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-dz.png')} alt='' />
                    </div>
                    <div className="item-text">收货地址管理</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                        
                    >查看</Button></div>
                </div>
                <div className="item"  onClick={() => {
                            history.push(`/members/report`);
                            history.go();
                        }
                        }>
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-bgcx.png')} alt='' />
                    </div>
                    <div className="item-text">健康档案</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                       
                    >查看</Button></div>
                </div>
                <div className="item"  onClick={() => {
                            history.push(`/members/interpret/0`);
                            history.go();
                        }
                        }>
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-bgjd.png')} alt='' />
                    </div>
                    <div className="item-text">报告解读</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline
                       
                    >查看</Button></div>
                </div>
                 <div className="item"  onClick={() => {
                            history.push(`/members/settings`);
                            history.go();
                        }
                        }>
                    <div className="item-ico">
                        <img src={require('../../res/images/user/ico-setting.png')} alt='' />
                    </div>
                    <div className="item-text">设置</div>
                    <div className="item-button"><Button className="smallbut" size="small" inline>查看</Button></div>
                </div> 
            </div>
            <Footer selectedTab='members' />
        </div>;
    }
}